var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36667 4.5C7.30498 4.5 5.63333 6.17005 5.63333 8.23125C5.63333 10.2924 7.30498 11.9625 9.36667 11.9625C11.4284 11.9625 13.1 10.2924 13.1 8.23125C13.1 6.17005 11.4284 4.5 9.36667 4.5Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23333 14.0938C5.17159 14.0938 3.5 15.7646 3.5 17.8265V20.4903H15.2333V17.8265C15.2333 15.7646 13.5617 14.0938 11.5 14.0938H7.23333Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 15.1667H16.3V20.5H19.5V17.8333C19.5 16.3606 18.3061 15.1667 16.8333 15.1667Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7667 8.76667C14.2939 8.76667 13.1 9.96057 13.1 11.4333C13.1 12.9061 14.2939 14.1 15.7667 14.1C17.2394 14.1 18.4333 12.9061 18.4333 11.4333C18.4333 9.96057 17.2394 8.76667 15.7667 8.76667Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/UsersIcon.e948f5759c0870637e83b9110393064d.svg";
export { ForwardRef as ReactComponent };